import React from "react";
import { graphql, useFragment } from "react-relay";
import { WorkspaceSignalListItemDescription_signal$key } from "./__generated__/WorkspaceSignalListItemDescription_signal.graphql";
import { ListItemDescriptionContent } from "../../Team/TeamHomeNavigator/TeamScheduleListItem/ListItemDescriptionContent";

export function WorkspaceSignalListItemDescription(props: {
  workspaceSignal: WorkspaceSignalListItemDescription_signal$key;
}) {
  const workspaceSignal = useFragment(
    graphql`
      fragment WorkspaceSignalListItemDescription_signal on SignalWorkspace {
        id
        title
        body
        descriptionImages {
          ...ListItemDescriptionContent_images
        }
        descriptionFiles {
          ...ListItemDescriptionContentFiles_files
        }
      }
    `,
    props.workspaceSignal
  );

  return (
    <ListItemDescriptionContent
      images={workspaceSignal.descriptionImages}
      title={workspaceSignal.title}
      description={workspaceSignal.body}
      files={workspaceSignal.descriptionFiles}
      products={[]}
    />
  );
}
